import api from '@/api'
import requestHelper from '@/utilities/requestHelper'

export default {
    state: ()=> ({
        nrpData:{},
        cruiseSearchPage: setCruiseSearchPage({}),
        cruiseFilters: [],
        cruiseLists: {
            items: [],
            count: 0
        },
        filterRequest: {
            "hp": { 
                "departures": [],
                "destinations": [],
                "sailDates": [],
                "sailDays": [],
                "shipCodes": [],
                 "tripModes": [],
                "tags": []
            },
            "row": {
                "departures": [],
                "destinations": [],
                "sailDates": [],
                "sailDays": [],
                "shipCodes": [],
                 "tripModes": [],
                "tags": []
            }
        },
        filterResponse: {
            "hp": {
                "departures": [],
                "destinations": [],
                "sailDates": [],
                "sailDays": [],
                "shipCodes": [],
                "tripModes": [],
                "tags": []
            },
            "row": {
                "departures": [],
                "destinations": [],
                "sailDates": [],
                "sailDays": [],
                "shipCodes": [],
                "tripModes": [],
                "tags": []
            }
        },
        cruiseDetail: {
            success: true,
            data: {},
            shipCode: '',
            sailDate: '',
        }
    }),
    actions: {
        GET_CRUISE_FILTERS_ROW: async({ commit }) => {
            const { success, data, errMsg } = await api.cruise.getCruiseFilter()
            if (!success) {
                console.error(errMsg)
                return Promise.reject()
              }
              if (data) {
                commit('GET_CRUISE_FILTERS_ROW', {
                    cruiseFilters: data
                })
              }
        },
        RESET_CRUISE_FILTERS_ROW: ({ commit })=> {
            commit('RESET_CRUISE_FILTERS_ROW')
        },
        SET_CRUISE_FILTERS_ROW: ({ commit }, { cruiseType, key, values}) => {
            commit('SET_CRUISE_FILTERS_ROW', { cruiseType, key, values })
        },
        INIT_CRUISE_FILTER_LIST_ROW: ({ commit }, { cruiseType, data}) => {
            commit('INIT_CRUISE_FILTER_LIST_ROW', { cruiseType, data})
        },
        REMOVE_CRUISE_FILTERS_ROW: ( { commit }, { cruiseType, key, values})=> {
            commit('REMOVE_CRUISE_FILTERS_ROW', { cruiseType, key, values })
        },
        RESET_DESTINATION_FILTERS_ROW: ({ commit }, { cruiseType })=> {
            commit('RESET_DESTINATION_FILTERS_ROW', { cruiseType })
        },
        CRUISE_SEARCH_ROW: ({ commit }, { data } ) => {
            return commit('CRUISE_SEARCH_ROW', { requestData: data})
        },
        GET_CRUISE_DETAIL_ROW: ( { commit, rootState}, { requestData }) => {
            return commit('GET_CRUISE_DETAIL_ROW', { requestData, rootState })
        }
    },
    mutations: {
        GET_CRUISE_FILTERS_ROW: (state, { cruiseFilters }) => {
            if (cruiseFilters) {
                state.cruiseFilters = cruiseFilters
            }
        },
        RESET_CRUISE_FILTERS_ROW: (state) => {
            state.filterRequest = {
                "hp": {
                    "departures": [],
                    "destinations": [],
                    "sailDates": [],
                    "sailDays": [],
                    "shipCodes": [],
                     "tripModes": [],
                    "tags": []
                },
                "row": {
                    "departures": [],
                    "destinations": [],
                    "sailDates": [],
                    "sailDays": [],
                    "shipCodes": [],
                     "tripModes": [],
                    "tags": []
                }
            }
            setCruiseFilterHandler(state, 'hp')
            setCruiseFilterHandler(state, 'row')
        },
        SET_CRUISE_FILTERS_ROW: (state, { cruiseType, key, values }) => {
            let filterRequest = state.filterRequest[cruiseType][key]
            values.forEach((value) => {
                if (!filterRequest.some(filter => filter.code == value.code)) {
                    filterRequest.push(value)
                }
            })
            state.filterRequest[cruiseType][key] = filterRequest
            setCruiseFilterHandler(state, cruiseType)
        },
        INIT_CRUISE_FILTER_LIST_ROW: (state, { cruiseType, data}) => {
            // 先初始化数据
            state.filterRequest = {
                "hp": {
                    "departures": [],
                    "destinations": [],
                    "sailDates": [],
                    "sailDays": [],
                    "shipCodes": [],
                    "tags": [],
                     "tripModes": [],
                    "keywords":[]
                },
                "row": {
                    "departures": [],
                    "destinations": [],
                    "sailDates": [],
                    "sailDays": [],
                    "shipCodes": [],
                    "tags": [],
                     "tripModes": [],
                    "keywords":[]
                }
            }
            data.forEach((item) => {
                let filterRequest = state.filterRequest[cruiseType][item.key]
                item.values.forEach((value) => {
                    console.log(value)
                    if (!filterRequest.some(filter => filter.code == value.code)) {
                        filterRequest.push(value)
                    }
                })
            })
            setCruiseFilterHandler(state, cruiseType)
        },
        REMOVE_CRUISE_FILTERS_ROW: (state, { cruiseType, key, values }) => {
            let filterRequest = state.filterRequest[cruiseType][key]
            values.forEach((value) => {
                filterRequest = filterRequest.filter(item => !(item.code == value.code))
            })
            state.filterRequest[cruiseType][key] = filterRequest
            setCruiseFilterHandler(state, cruiseType)
        },
        RESET_DESTINATION_FILTERS_ROW: (state, { cruiseType }) => {
            state.filterRequest[cruiseType].destinations = []
            setCruiseFilterHandler(state, cruiseType)
        },
        SET_CRUISE_SEARCH_PAGE_ROW: (state, { data}) => {
            state.cruiseSearchPage = setCruiseSearchPage(data)
        },
        CRUISE_SEARCH_ROW: async (state, { requestData }) => {
            let request = requestHelper.generateCruiseSearchRequest(requestData, 'hp')
            const { success, data, errMsg } = await api.cruise.cruiseSearch(request,true)
            if (!success) {
                console.error(errMsg)
                return
            }
            state.cruiseLists = {
                items: data.cruises || [],
                count: data.count
            }
        },
        GET_CRUISE_DETAIL_ROW: async(state, { requestData }) => {
            const cruiseDetail = state.cruiseDetail;
            if (cruiseDetail.shipCode == requestData.shipCode && cruiseDetail.sailDate == requestData.sailDate) {
                return;
            }
            state.cruiseDetail.shipCode = requestData.shipCode
            state.cruiseDetail.sailDate = requestData.sailDate
            const { success, data, errMsg } = await api.cruise.getCruiseDetail(requestData);
            if (!success) {
                console.error(errMsg);
            }
            state.cruiseDetail = { success, data, shipCode: requestData.shipCode, sailDate: requestData.sailDate };
            
        },
        SET_CRUISE_DETAIL_SAILING_ROW: (state, { shipCode, sailDate }) => {
            state.cruiseDetail.shipCode = shipCode
            state.cruiseDetail.sailDate = sailDate
        },
        SET_CRUISE_DETAIL_ROW: (state, { success, data}) => {
            state.cruiseDetail.success = success
            state.cruiseDetail.data = data
        },
        SET_NRP_DATA_NEW:(state, data) => {
            // console.log(data,'获取收费退订和常规退订文案')
            state.nrpData = data
        },
    }
}

async function setCruiseFilterHandler(state, cruiseType) {
    const request = requestHelper.generateCruiseSearchRequest(state.filterRequest[cruiseType], cruiseType)
    const { success, data, errMsg } = await api.cruise.setCruiseFilterRow(request)
    if (!success) {
        console.error(errMsg)
    }
    state.filterResponse[cruiseType] = data
}


function setCruiseSearchPage(data) {
    return {
        "cruiseFilters": data.cruiseFilters || [],
        "months": data.months || [],
        "tags": data.tags || [],
        "mobilePopupImage": data.mobilePopupImage || {},
        "tagTopShowList": data.tagTopShowList || [],
        "seoViewModel": data.seoViewModel || {},
        "cruiseHomeBanner": {
            "imageUrl": data.homeBannerImg || "",
            "link": data.homeBannerUrl || ""
        },
        "cruiseTopSells": data.cruiseTopSells || [],
        "cruiseSearchBanners": data.cruiseSearchBanners || [],
        "homeBanner": {
            "image": data.homeBannerImg || "",
            "url": data.homeBannerUrl || ""
        },
        "tagHolidayList":data.tagHolidayList || [],
        "tagPromoList":data.tagPromoList || [],
        "tagThemeList":data.tagThemeList || []
    }
}